// Decorator custom qui proxy le decorator de swagger si l'import existe. Sinon rien faire.
// 2 DTOs. 1 common et 1 API avec des implements d'interfaces.
// Config le bundle pour alias @nestjs/swagger vers notre "polyfill" sur le front
export * from './catalog';
export * from './shop.dto';
export * from './payment-method.dto'
export * from './customer.dto';   
export * from './organization.dto';
export * from './loyalty.dto';
export * from './user.dto';
export * from './role.dto';
export * from './delivery-zone.dto';

export * from './payment-provider.dto';